export const activateIntegration = ({ token, id }) => ({
  HTTPMethod: "post",
  path: `/api/v1/conduit/integrations/${encodeURIComponent(id)}/activate`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
